import React, {FC} from 'react'
import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'
import moment from 'moment'

type Grouping = 'day' | 'month' | 'year'

type PointsTrendPoint = {
  date: string
  earned: number
  redeemed: number
  reversed: number
  expired: number
}

type PointsTrendChartProps = {
  data: PointsTrendPoint[]
  grouping: Grouping
}

const formatXAxis = (dateStr: string, grouping: Grouping) => {
  if (grouping === 'day') return moment(dateStr).format('DD/MM')
  if (grouping === 'month') return moment(dateStr).format('MMM YYYY')
  return dateStr
}

const PointsTrendChart: FC<PointsTrendChartProps> = ({data, grouping}) => {
  const categories = data.map((item) => formatXAxis(item.date, grouping))

  const series = [
    {name: 'Gerados', type: 'column', data: data.map((item) => item.earned)},
    {name: 'Resgatados', type: 'column', data: data.map((item) => item.redeemed)},
    {name: 'Estornados', type: 'line', data: data.map((item) => item.reversed)},
    {name: 'Expirados', type: 'line', data: data.map((item) => item.expired)},
  ]

  const options: ApexOptions = {
    chart: {
      id: 'hotel-points-trend-chart',
      toolbar: {show: false},
      zoom: {enabled: false},
    },
    stroke: {
      width: [0, 0, 3, 3],
      curve: 'smooth',
    },
    colors: ['#009EF7', '#F1416C', '#FFC700', '#7E8299'],
    xaxis: {
      categories,
      labels: {
        style: {colors: '#A1A5B7', fontSize: '12px'},
      },
      axisBorder: {show: false},
      tooltip: {enabled: false},
    },
    yaxis: {
      min: 0,
      title: {
        text: 'Pontos',
        style: {color: '#7E8299', fontWeight: 600},
      },
      labels: {
        formatter: (val) => Math.round(val).toString(),
        style: {colors: '#A1A5B7'},
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '45%',
      },
    },
    dataLabels: {enabled: false},
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => (typeof y === 'undefined' ? y : `${Math.round(y)} pts`),
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      labels: {colors: '#7E8299'},
    },
    grid: {
      borderColor: '#E4E6EF',
      strokeDashArray: 4,
    },
  }

  return <Chart options={options} series={series} type='line' height={350} />
}

export default PointsTrendChart
